import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const useQueryBIRequestResult = (id: number) => {
  return useQuery({
    queryKey: ['bi-request-result', id],
    queryFn: async () => {
      const { data } = await axios.get(`benefit_investigation_results/${id}`);
      return data;
    },
    retry: 0,
    enabled: !!localStorage.getItem('Authorization') && !!id,
  });
};
